import { spacing } from 'styles/helpers';
import { theme, typography } from 'styles/theme';
import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Google Sans Regular',
  fonts: [
    { src: require('fonts/GoogleSans-Regular.ttf') },
  ],
});

const DISCLAIMER_TEXT_FONT_PDF = 'Google Sans Regular';

const styles = StyleSheet.create({
  disclaimerWrapper : {
    padding: `${spacing.l} ${spacing.m} 0 ${spacing.m} `
  },
  disclaimerParagraph: {
    color:  theme.colors.disclaimer,
    marginBottom: spacing['2xs'],
    fontFamily: DISCLAIMER_TEXT_FONT_PDF,
    fontSize: 10,
    fontWeight: typography.body5.fontWeight,
  }
});

export default styles;